import React from "react";
import { IconProps } from "../Interfaces";

export const MavenIcon: React.FC<IconProps> = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path d="M31.918 30.136z" fill="#BE202E" />
      <path opacity=".35" d="M31.918 30.136z" fill="#BE202E" />
      <path
        d="M31.704 29.682c-.001.001-.001.001 0 0l.014-.012.055-.054-.069.066z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M31.704 29.682c-.001.001-.001.001 0 0l.014-.012.055-.054-.069.066z"
        fill="#BE202E"
      />
      <path
        d="M31.878 30.179c-.014.014-.03.027-.045.043.014-.014.028-.029.045-.043z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M31.878 30.179c-.014.014-.03.027-.045.043.014-.014.028-.029.045-.043z"
        fill="#BE202E"
      />
      <path d="m31.704 29.683.015-.013-.015.013z" fill="#BE202E" />
      <path
        opacity=".35"
        d="m31.704 29.683.015-.013-.015.013z"
        fill="#BE202E"
      />
      <path
        d="M7.713 23.019h2.662c.185 0 .316.038.392.114a.348.348 0 0 1 .114.245c.011.098.027.196.05.294l.065.539c.032.174.06.353.081.539.12.685.218 1.382.294 2.09.087.707.19 1.41.31 2.106.044.218.077.441.098.67.022.228.055.451.098.67l.033.162c.01.055.038.098.082.131.021.01.038.022.049.033.021.01.049.005.081-.017.087-.021.158-.087.213-.196.054-.108.108-.206.163-.294.13-.25.256-.495.376-.734.12-.25.25-.501.391-.752.349-.663.697-1.328 1.045-1.992a178.817 178.817 0 0 0 1.323-2.53c.098-.175.19-.35.278-.523.043-.087.092-.174.147-.262a.615.615 0 0 1 .228-.212.438.438 0 0 1 .262-.081H19.356c.11 0 .185.021.229.065.109.065.141.19.098.375-.033.175-.066.354-.098.54l-.49 2.449-1.225 6.074-.277 1.42c-.022.12-.05.24-.082.36a.447.447 0 0 1-.163.245.545.545 0 0 1-.262.098h-1.55a1.957 1.957 0 0 0-.213-.049c-.055-.01-.098-.049-.13-.114a.327.327 0 0 1-.033-.212l.065-.278.163-.833.85-4.197c.021-.152.043-.293.065-.424.032-.142.06-.283.081-.425l.066-.261a1.28 1.28 0 0 0 .032-.278.929.929 0 0 1 0-.245c.022-.087.006-.141-.049-.163-.032-.01-.06-.005-.081.017l-.05.049a.715.715 0 0 0-.146.163l-.098.163c-.098.163-.196.332-.294.506a6.28 6.28 0 0 1-.294.523l-.098.196a.825.825 0 0 1-.098.196 8.483 8.483 0 0 0-.245.424 4.04 4.04 0 0 1-.229.425.361.361 0 0 0-.049.114.414.414 0 0 1-.049.098 2.878 2.878 0 0 0-.18.31 1.62 1.62 0 0 1-.179.327 2.88 2.88 0 0 0-.18.31 2.298 2.298 0 0 1-.163.327c-.196.316-.375.637-.539.963a39.99 39.99 0 0 1-.506.947.256.256 0 0 0-.065.098c0 .033-.017.066-.05.098-.075.12-.146.245-.211.376-.055.12-.12.24-.196.36a3.62 3.62 0 0 1-.131.211.71.71 0 0 1-.147.164.515.515 0 0 1-.18.081.92.92 0 0 0-.212.033h-.376c-.076 0-.168.005-.277.016h-.31c-.098 0-.19-.005-.278-.016-.087-.01-.147-.033-.18-.065a.373.373 0 0 1-.147-.18 1.51 1.51 0 0 0-.065-.261 4.848 4.848 0 0 1-.049-.392 2.444 2.444 0 0 0-.065-.408l-.017-.147a2.457 2.457 0 0 1-.065-.409 2.481 2.481 0 0 0-.065-.424v-.082a.308.308 0 0 0-.016-.098 1.427 1.427 0 0 1-.066-.31 3.376 3.376 0 0 0-.049-.326v-.082a.182.182 0 0 0-.016-.082 3.38 3.38 0 0 1-.05-.326c0-.11-.015-.218-.048-.327a11.253 11.253 0 0 1-.114-.686 7.268 7.268 0 0 0-.098-.702c-.044-.272-.082-.55-.115-.833a4.006 4.006 0 0 0-.147-.816 1.436 1.436 0 0 0-.098-.376.256.256 0 0 0-.065-.049c-.01-.022-.033-.022-.065 0a.25.25 0 0 0-.13.163.903.903 0 0 1-.066.23.652.652 0 0 0-.082.244l-.033.245c-.021.12-.048.24-.081.36-.022.119-.05.239-.082.358l-.865 4.344-.164.8-.065.261a.352.352 0 0 1-.098.213c-.054.076-.147.125-.277.147a.887.887 0 0 1-.245.032 2.102 2.102 0 0 0-.262-.016H5.297a.37.37 0 0 1-.229-.098c-.054-.054-.076-.136-.065-.245l.065-.36.278-1.436L6.57 26.43l.458-2.286c.01-.065.021-.141.032-.228a10.852 10.852 0 0 1 .13-.523 2.18 2.18 0 0 1 .082-.196.55.55 0 0 1 .294-.163c.033-.011.055-.011.066 0a.271.271 0 0 0 .081-.016zM27.231 34.008a2 2 0 0 1-.033.36.306.306 0 0 1-.212.244.617.617 0 0 1-.245.05h-1.437a.326.326 0 0 1-.196-.082.312.312 0 0 1-.13-.18.445.445 0 0 0-.115-.212.205.205 0 0 0-.081-.05c-.022-.02-.06-.026-.115-.015a.901.901 0 0 0-.18.081c-.054.033-.108.06-.163.082a1.323 1.323 0 0 1-.212.114 3.479 3.479 0 0 1-.686.261c-.163.033-.326.071-.49.115a1.012 1.012 0 0 1-.245.032l-.212.033h-.098a.308.308 0 0 1-.098.016h-.18a.822.822 0 0 1-.326 0h-.147a.831.831 0 0 0-.229-.032.401.401 0 0 1-.195-.017l-.294-.065a.67.67 0 0 1-.262-.082 2.147 2.147 0 0 1-.718-.457 1.546 1.546 0 0 1-.376-.767 1.624 1.624 0 0 1-.049-.245c0-.087-.005-.18-.016-.278a.412.412 0 0 1 0-.163.436.436 0 0 0 .033-.163c0-.033.005-.098.016-.196.022-.11.043-.186.065-.229a1.25 1.25 0 0 0 .082-.278l.163-.359a2.774 2.774 0 0 1 .98-1.061c.272-.164.61-.305 1.012-.425.153-.054.305-.092.457-.114a8.66 8.66 0 0 0 .474-.082c.087-.021.18-.032.278-.032.109-.011.212-.028.31-.05a.545.545 0 0 1 .229-.016c.076 0 .163-.01.26-.032a.828.828 0 0 1 .23-.033c.076 0 .157-.011.244-.033.24-.054.458-.098.653-.13.207-.044.403-.142.588-.294.11-.098.196-.207.262-.327a.267.267 0 0 0 .016-.081c0-.022.005-.044.016-.066.022-.022.033-.054.033-.098a.513.513 0 0 1 .033-.098v-.245c-.044-.326-.229-.55-.556-.67a1.277 1.277 0 0 0-.343-.065 1.691 1.691 0 0 0-.408-.016c-.141 0-.283.011-.424.033-.13.022-.245.049-.343.081a.757.757 0 0 0-.212.098 1.438 1.438 0 0 0-.408.294.856.856 0 0 0-.164.213 3.554 3.554 0 0 0-.196.31.413.413 0 0 1-.277.196 1.14 1.14 0 0 1-.278.032H21.402c-.055 0-.115.006-.18.017a.424.424 0 0 1-.13-.017h-.148a.182.182 0 0 0-.081-.016.11.11 0 0 1-.082-.032c-.076-.022-.12-.093-.13-.213 0-.054.01-.109.032-.163a4.534 4.534 0 0 1 .229-.473c.065-.11.13-.207.195-.295l.131-.163.13-.163c.11-.12.24-.234.393-.343a.323.323 0 0 0 .114-.082c.065-.043.12-.081.163-.114a2.67 2.67 0 0 1 .18-.098c.207-.12.419-.212.637-.278.228-.076.457-.147.686-.212a2.87 2.87 0 0 1 .424-.065c.142-.011.289-.033.441-.066a.575.575 0 0 1 .196 0c.087.011.147.006.18-.016.446-.01.865.006 1.257.05.403.043.756.124 1.061.244.316.12.572.283.768.49.207.196.343.452.408.767.033.185.033.398 0 .637-.033.24-.076.485-.13.735l-.735 3.642c-.033.206-.071.419-.115.636-.043.207-.06.398-.049.572 0 .033-.005.07-.016.114v.098zm-1.894-2.515a.865.865 0 0 0 .049-.18c.01-.075.016-.14.016-.195 0-.065.006-.125.016-.18a.122.122 0 0 0-.049-.13c-.043-.044-.12-.066-.228-.066a1.58 1.58 0 0 0-.114.033.7.7 0 0 0-.131.016 1.625 1.625 0 0 1-.245.05c-.087.01-.18.026-.278.048a.496.496 0 0 1-.147.017c-.152.032-.299.054-.44.065-.142.01-.284.038-.425.082l-.261.065a.907.907 0 0 0-.229.065c-.25.098-.473.245-.67.441-.195.196-.31.468-.342.817a.753.753 0 0 0 .098.457c.043.12.136.217.277.294.142.065.3.114.474.147.174.032.359.043.555.032a3.31 3.31 0 0 0 .588-.114c.305-.087.555-.223.751-.408.207-.196.381-.436.523-.719.032-.076.06-.152.081-.228.022-.087.055-.175.098-.262l.033-.146zM46.169 30.367a.8.8 0 0 1-.065.293c-.044.11-.098.18-.164.213a.574.574 0 0 1-.245.098l-.359.032h-.375a3.631 3.631 0 0 0-.327-.016h-4.213a.503.503 0 0 0-.376.163.979.979 0 0 0-.098.131.315.315 0 0 0-.049.163c.011.066.011.131 0 .196 0 .055.006.115.017.18.032.261.092.479.18.653.097.163.239.31.424.441a.72.72 0 0 0 .245.114c.098.011.19.033.277.066a2.14 2.14 0 0 0 .752.032h.147a14.3 14.3 0 0 0 .31-.065l.294-.098c.12-.055.256-.125.408-.212.153-.087.272-.174.36-.262.065-.076.135-.147.212-.212a.69.69 0 0 1 .245-.163.875.875 0 0 1 .424-.066H44.863a.38.38 0 0 1 .196.017h.163a.572.572 0 0 1 .212.082c.033.021.044.07.033.146a.374.374 0 0 1-.05.196c-.086.153-.179.289-.277.409-.087.12-.185.24-.294.359-.305.36-.631.648-.98.865a5.388 5.388 0 0 1-1.257.556c-.13.043-.256.07-.375.081-.12.011-.25.033-.392.066a.334.334 0 0 1-.147 0 .535.535 0 0 0-.13.016h-.18a.403.403 0 0 1-.197.016.916.916 0 0 1-.18-.016.8.8 0 0 0-.228 0 .48.48 0 0 1-.212-.017.48.48 0 0 0-.18-.032.364.364 0 0 1-.163-.033 4.26 4.26 0 0 1-.36-.081.868.868 0 0 1-.293-.115 5.72 5.72 0 0 0-.31-.114 1.485 1.485 0 0 1-.262-.147 3.68 3.68 0 0 1-.783-.751 3.07 3.07 0 0 1-.523-1.372c0-.13-.016-.261-.049-.392v-.114a.536.536 0 0 0 .016-.13c-.01-.131-.01-.273 0-.425l.066-.457a.916.916 0 0 0 .016-.18.865.865 0 0 1 .049-.18l.049-.196.13-.392c.077-.185.148-.364.213-.539.065-.174.147-.337.245-.49.697-1.132 1.654-1.932 2.874-2.4.163-.065.326-.109.49-.13.163-.033.337-.071.522-.115.087-.01.169-.016.245-.016.076 0 .158-.006.245-.016.555-.011 1.018.054 1.388.196.37.13.691.304.964.522.087.066.168.142.244.229.087.076.158.158.213.245.022.054.06.098.114.13.065.12.12.245.163.376.055.12.115.245.18.376.033.098.054.2.065.31.022.098.044.207.066.326.021.142.032.289.032.441l.033.457c0 .088-.016.186-.05.294a.81.81 0 0 0-.015.278l-.033.18zm-2.27-.964c.098-.109.13-.24.098-.392a39.672 39.672 0 0 0-.049-.359 1.28 1.28 0 0 0-.473-.67c-.218-.163-.55-.25-.997-.26a.137.137 0 0 1-.114.016.203.203 0 0 0-.114 0c-.065.021-.13.038-.196.049a.479.479 0 0 0-.18.032 2.282 2.282 0 0 0-1.355 1.078.752.752 0 0 0-.098.212.616.616 0 0 0-.033.196c0 .066.028.12.082.163.076.055.19.082.343.082H43.54c.174-.01.294-.06.36-.147zM53.21 26.023c.654-.022 1.176.07 1.568.278.403.206.686.511.85.914.054.12.086.25.097.392.022.13.038.267.05.408a.92.92 0 0 1 0 .245.803.803 0 0 0 0 .229c-.023.065-.028.109-.017.13a3.79 3.79 0 0 1-.066.474c-.032.163-.065.321-.097.474l-.278 1.453-.539 2.645c-.043.207-.087.408-.13.604-.044.185-.148.305-.31.36a.726.726 0 0 1-.23.032h-1.143c-.13 0-.244-.005-.342-.016a.308.308 0 0 1-.213-.147.435.435 0 0 1-.032-.245c.022-.109.043-.223.065-.343l.229-1.143.49-2.433c.076-.403.13-.773.163-1.11.043-.349.005-.643-.114-.882-.11-.218-.3-.37-.572-.457a.48.48 0 0 0-.18-.033.437.437 0 0 1-.163-.033.684.684 0 0 0-.212 0 .775.775 0 0 0-.18.017.708.708 0 0 1-.13.016.308.308 0 0 0-.099.016 2.268 2.268 0 0 0-.653.262c-.402.25-.685.615-.849 1.094a15.152 15.152 0 0 0-.408 1.616l-.408 2.041-.196.996-.066.294a.72.72 0 0 1-.097.245.443.443 0 0 1-.31.213c-.12.021-.267.032-.442.032h-.816c-.12 0-.24-.005-.36-.016s-.195-.05-.228-.114c-.065-.098-.076-.24-.033-.425.044-.185.082-.36.115-.523l.44-2.22.72-3.593.179-.833c.022-.12.043-.228.065-.326a.44.44 0 0 1 .147-.245c.022-.033.06-.055.114-.065a.927.927 0 0 1 .164-.05h.081a.83.83 0 0 1 .163-.016H49.864c.087 0 .169.006.245.017.087 0 .163.01.229.032a.195.195 0 0 1 .114.147.724.724 0 0 1 .032.229.365.365 0 0 1-.016.114.15.15 0 0 0 0 .098c.011.055.022.087.033.098.022.011.049.027.081.05a.398.398 0 0 0 .31-.115c.099-.098.197-.174.295-.229a4.935 4.935 0 0 1 1.077-.522c.11-.033.213-.055.31-.066a5.56 5.56 0 0 0 .36-.049.328.328 0 0 1 .147 0 .34.34 0 0 0 .13-.016zM57.254 26.01c.01.009.016.027.016.056a.187.187 0 0 1-.016.078l-.003.026a.208.208 0 0 1-.03.05.089.089 0 0 1-.042.025.393.393 0 0 1-.082.007 1.511 1.511 0 0 0-.088-.003h-.05a.048.048 0 0 1-.029.003.038.038 0 0 0-.026.003c-.024.009-.044.03-.062.062a.104.104 0 0 0-.013.04l-.006.045-.157.77a.15.15 0 0 0-.003.03.059.059 0 0 1-.007.026l-.006.027a4.468 4.468 0 0 0-.007.02c0 .006-.003.011-.01.016a.07.07 0 0 1-.042.035.105.105 0 0 1-.04.007H56.406c-.037 0-.062-.009-.075-.026-.007-.013-.01-.028-.007-.046a1.27 1.27 0 0 0 .013-.059l.154-.77.006-.033a.048.048 0 0 0 .003-.03l.007-.045c.002-.035-.009-.057-.033-.066a.167.167 0 0 0-.088-.013c-.037.003-.07.004-.098.004a.173.173 0 0 0-.032.003.072.072 0 0 1-.023-.003c-.01-.005-.017-.006-.023-.004a.06.06 0 0 1-.02-.003.049.049 0 0 1-.03-.052.83.83 0 0 1 .02-.12.226.226 0 0 1 .017-.034.053.053 0 0 1 .026-.023.237.237 0 0 1 .032-.016c.007-.002.011-.002.014 0 .004 0 .01 0 .016-.003h.872c.02 0 .038.001.055.003.018 0 .032.005.043.013zm1.737.007a.07.07 0 0 1 .007.052.952.952 0 0 1-.01.065l-.212 1.062a.475.475 0 0 1-.017.065.112.112 0 0 1-.023.046c-.015.017-.039.026-.071.026h-.092a.298.298 0 0 0-.042.003.074.074 0 0 1-.033-.006c-.02-.007-.031-.017-.036-.03a.303.303 0 0 1-.003-.049l.01-.055c0-.007 0-.014.003-.023a.799.799 0 0 1 .006-.03l.085-.414.014-.079a.295.295 0 0 0 .01-.072.138.138 0 0 1-.004-.026.022.022 0 0 0-.01-.02c-.002-.001-.005-.003-.01-.003a.205.205 0 0 1-.022.014.513.513 0 0 0-.06.088 6.273 6.273 0 0 0-.17.3 5.959 5.959 0 0 1-.113.2 2.13 2.13 0 0 0-.056.104.217.217 0 0 1-.068.082.104.104 0 0 1-.046.016H57.923a.24.24 0 0 0-.029-.01.083.083 0 0 1-.023-.016.05.05 0 0 1-.013-.026 3.778 3.778 0 0 0-.02-.092.644.644 0 0 0-.01-.065 2.755 2.755 0 0 1-.032-.193 2.605 2.605 0 0 0-.033-.196l-.02-.11a.192.192 0 0 0-.035-.096c-.005 0-.008.002-.01.004h-.007a.073.073 0 0 0-.022.03.104.104 0 0 0-.013.032.08.08 0 0 1-.007.03l-.01.055a.132.132 0 0 0-.013.049l-.078.379c-.005.028-.011.063-.02.104a.2.2 0 0 1-.03.085.13.13 0 0 0-.019.016.041.041 0 0 1-.016.01.166.166 0 0 1-.04.01h-.13a.098.098 0 0 1-.065-.02c-.011-.008-.017-.022-.017-.042a.943.943 0 0 1 .01-.065l.216-1.078.013-.056a.148.148 0 0 1 .023-.045.078.078 0 0 1 .052-.03c.006-.002.01-.002.013 0 .004 0 .01 0 .016-.003H57.838c.022 0 .038.005.05.016.017.013.027.034.029.062a31.304 31.304 0 0 1 .082.45 7.118 7.118 0 0 0 .049.245.04.04 0 0 0 .026.027c.01.004.02.002.029-.006a.336.336 0 0 0 .075-.098c.015-.029.03-.056.046-.082.046-.072.088-.145.127-.219.041-.076.085-.15.13-.222.018-.03.036-.062.053-.095a.156.156 0 0 1 .078-.072.165.165 0 0 1 .046-.006h.236a.103.103 0 0 1 .035 0h.017a.12.12 0 0 0 .026.01c.01.002.017.006.02.013z"
        fill="#2684FF"
      />
      <path
        d="M37.313 26.035c-.204.03-.55.181-.962.425l.336.615c.269-.198.542-.366.814-.499l.032-.016-.032.016c-.089.044-.357.192-.767.523.374.093.948.202 1.419.277.17-.537-.091-.881-.091-.881s-.33-.523-.75-.46z"
        fill="url(#a)"
      />
      <path d="M35.5 31.001z" fill="#BE202E" />
      <path opacity=".35" d="M35.5 31.001z" fill="#BE202E" />
      <path
        d="M35.693 30.46c-.002 0-.002 0 0 0 .007.001.014 0 .02.002.03.002.058.004.085.004l-.105-.006z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M35.693 30.46c-.002 0-.002 0 0 0 .007.001.014 0 .02.002.03.002.058.004.085.004l-.105-.006z"
        fill="#BE202E"
      />
      <path
        d="M35.505 28.643c.127-.129.254-.254.381-.375a8.582 8.582 0 0 1 .832-.695l-.358-.663-.092.055c-.117.07-.24.147-.364.23a13.787 13.787 0 0 0-1.203.91l-.014.012.465.897.353-.37z"
        fill="url(#b)"
      />
      <path
        d="M32.661 33.255c-.069.11-.14.222-.209.339l-.002.004c-.01.017-.021.032-.03.05-.047.077-.087.149-.183.308.139.089.244.246.341.418-.004-.15-.078-.313-.227-.464.687.223 1.29.267 1.614-.02a1.02 1.02 0 0 0 .082-.084c-.147.09-.322.097-.648-.012l-.002-.001h.002c.488-.02.736-.104.962-.296a1.95 1.95 0 0 0 .16-.155c-.436.2-.927.148-1.435-.07l-.385-.08-.04.063z"
        fill="url(#c)"
      />
      <path
        d="m33.136 32.261.312-.45c.102-.144.206-.288.314-.433.107-.145.217-.289.327-.433.113-.147.228-.292.346-.435.116-.143.236-.284.354-.424.043-.05.086-.1.132-.15.075-.084.152-.169.23-.253.002-.005.008-.01.01-.014l-.481-.924c-.008.008-.017.017-.028.024-.13.112-.263.225-.39.344a10.778 10.778 0 0 0-.694.698l-.06.067a7.109 7.109 0 0 0-.65.856 7.98 7.98 0 0 0-.165.273c-.041.075-.08.153-.12.229a4.8 4.8 0 0 0-.234.55l.49.932c.076-.118.157-.235.237-.357l.07-.1z"
        fill="url(#d)"
      />
      <path
        d="M32.276 32.428c-.085.234-.15.474-.19.721 0 .008-.004.018-.004.026-.166-.252-.634-.586-.631-.583.322.448.563.87.58 1.221-.183-.025-.432-.135-.716-.291.292.281.514.4.602.439-.278-.066-.573-.012-.872.06.431-.002.779.047 1.022.157a35.916 35.916 0 0 0-1.313 2.231c.12.01.195-.029.24-.094a33.89 33.89 0 0 1 1.405-2.332l.07-.106.018-.03.265-.392c.022-.03.041-.06.063-.091v-.002l-.526-.96a.09.09 0 0 0-.013.026z"
        fill="url(#e)"
      />
      <path
        d="m34.949 29.642-.045.052c-.046.054-.093.107-.139.163l-.154.184c-.027.031-.053.062-.08.096-.08.098-.16.199-.243.303a24.339 24.339 0 0 0-.612.821c-.097.138-.196.279-.297.427-.089.13-.178.267-.27.406-.006.006-.009.014-.014.02a42.75 42.75 0 0 0-.28.437l.398.086-.025-.011c.477.098 1.12.021 1.542-.185.195-.096.374-.222.542-.383.126-.12.243-.259.359-.42.1-.138.197-.292.291-.463-.11.01-.237.004-.376-.015l-.074-.011-.077-.014c.45.006.74-.156.957-.399a1.686 1.686 0 0 1-.634.001l-.025-.005a1.68 1.68 0 0 0 .404-.048.578.578 0 0 0 .072-.021c.035-.012.068-.027.102-.041l.061-.03a.697.697 0 0 0 .13-.09c.013-.012.025-.021.036-.033.016-.018.032-.033.045-.05a2.134 2.134 0 0 0 .22-.29c.006-.012.014-.02.02-.032.016-.03.032-.058.043-.082a.597.597 0 0 0 .035-.09.233.233 0 0 1-.053.011 2.197 2.197 0 0 1-.56-.024l-.057-.01h.01l-1.25-.273c.003.009 0 .012-.002.013z"
        fill="url(#f)"
      />
      <path
        d="M36.59 27.506c-.114.091-.238.197-.372.316-.008.007-.015.012-.02.02a13.168 13.168 0 0 0-.72.71c-.108.113-.216.234-.331.363l1.208.252c.356-.019.519-.081.68-.195a3.61 3.61 0 0 0 .794-.817c.05-.074.089-.143.119-.206.024-.056.044-.11.061-.162a19.664 19.664 0 0 1-1.42-.281z"
        fill="url(#g)"
      />
      <path
        d="M35.435 31.002c-.022 0-.044-.003-.068-.004.022 0 .044.001.069.004z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M35.435 31.002c-.022 0-.044-.003-.068-.004.022 0 .044.001.069.004z"
        fill="#BE202E"
      />
      <path
        d="M35.435 31.002c-.022 0-.044-.003-.068-.004.022 0 .044.001.069.004z"
        fill="url(#h)"
      />
      <path
        d="M35.691 30.463c.007.001.013 0 .022.002-.006-.001-.013 0-.022-.002z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M35.691 30.463c.007.001.013 0 .022.002-.006-.001-.013 0-.022-.002z"
        fill="#BE202E"
      />
      <path
        d="M35.691 30.463c.007.001.013 0 .022.002-.006-.001-.013 0-.022-.002z"
        fill="url(#i)"
      />
      <path
        d="M30.228 24.794c.192.166.5.538.856 1.042l-.439.343a10.92 10.92 0 0 0-.727-1.046c.008.012.02.024.028.036.078.101.312.418.65 1-.38-.164-.959-.45-1.43-.697-.067-.612.25-.755.25-.755s.415-.263.812.078z"
        fill="url(#j)"
      />
      <path d="M30.013 30.079z" fill="#BE202E" />
      <path opacity=".35" d="M30.013 30.079z" fill="#BE202E" />
      <path
        d="M30.058 29.514c.002 0 .002 0 0 0l-.02-.008c-.028-.012-.056-.023-.081-.036l.1.044z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="M30.058 29.514c.002 0 .002 0 0 0l-.02-.008c-.028-.012-.056-.023-.081-.036l.1.044z"
        fill="#BE202E"
      />
      <path
        d="M31.128 27.989a36.93 36.93 0 0 0-.309-.614 18.01 18.01 0 0 0-.697-1.225l.479-.365.082.116c.102.147.21.303.318.467a29.153 29.153 0 0 1 1.025 1.682l.011.02-.627.509c-.096-.198-.189-.395-.282-.59z"
        fill="url(#k)"
      />
      <path
        d="M31.624 33.478c.047.148.095.3.141.456l.002.006.02.065.12.41c-.15-.011-.28.063-.407.156.032-.136.133-.236.306-.276-.71-.258-1.303-.625-1.567-1.11a2 2 0 0 1-.064-.134c.127.184.295.308.632.427l.003.001h-.003c-.47-.35-.697-.595-.88-.926a3.86 3.86 0 0 1-.128-.252c.387.48.874.764 1.409.906l.389.187.027.084z"
        fill="url(#l)"
      />
      <path
        d="m32.05 32.385-.227-.632a40.694 40.694 0 0 0-.48-1.245 30.139 30.139 0 0 0-.264-.643c-.09-.211-.184-.425-.275-.636a30.034 30.034 0 0 0-.286-.622l-.009-.021.661-.527c.007.013.014.027.024.041a21.142 21.142 0 0 1 .891 1.713l.048.104a13.104 13.104 0 0 1 .489 1.24c.041.128.08.25.114.367.027.099.052.198.077.295.056.23.098.453.13.672l-.67.53c-.055-.163-.115-.328-.171-.495l-.051-.141z"
        fill="url(#m)"
      />
      <path
        d="M31.926 32.54c.04.273.058.539.049.795l-.001.026c.22-.126.764-.132.76-.13-.419.206-.749.441-.838.757.193.096.468.157.789.196a1.768 1.768 0 0 1-.701.017c.296.12.586.362.876.625-.44-.284-.803-.465-1.073-.52.307.907.601 1.894.888 2.933a.458.458 0 0 1-.225-.244 52.325 52.325 0 0 0-.962-3.088c-.016-.047-.035-.095-.05-.144l-.013-.04a81.213 81.213 0 0 0-.191-.538l-.046-.125v-.002l.73-.55c.005.011.007.02.008.031z"
        fill="url(#n)"
      />
      <path
        d="m30.71 29.012.035.08.106.246.118.278.06.144a31.988 31.988 0 0 1 .412 1.038c.074.192.149.393.223.597.07.195.142.394.214.6l.191.565c.005.01.006.019.01.028.063.19.127.386.191.587.002.004.005.009.004.012l-.407-.196.026.006c-.487-.24-1.105-.757-1.483-1.241a4.526 4.526 0 0 1-.463-.73 5.667 5.667 0 0 1-.276-.638 7.802 7.802 0 0 1-.201-.631c.107.086.233.168.373.246l.075.042.078.04a2.43 2.43 0 0 1-.868-1.033c.112.105.299.258.528.39.03.017.063.034.096.05l.025.013a3.123 3.123 0 0 1-.455-.394 2.564 2.564 0 0 1-.093-.108c-.018-.025-.037-.047-.055-.071a1.506 1.506 0 0 1-.11-.174c-.012-.02-.023-.037-.03-.055-.013-.027-.026-.053-.036-.078a3.95 3.95 0 0 1-.163-.421c-.003-.015-.01-.028-.013-.043-.01-.04-.022-.076-.028-.107a.845.845 0 0 1-.018-.106.46.46 0 0 0 .05.046 3.534 3.534 0 0 0 .556.367l.058.03c-.002-.002-.008-.004-.01-.007l1.279.614a.01.01 0 0 0 0 .014z"
        fill="url(#o)"
      />
      <path
        d="M30.24 26.433c.094.161.195.343.304.544.006.011.012.021.016.032a25.797 25.797 0 0 1 .57 1.145c.084.177.167.362.256.559l-1.222-.583c-.343-.258-.49-.425-.625-.639a7.177 7.177 0 0 1-.623-1.293 2.546 2.546 0 0 1-.078-.272 2.333 2.333 0 0 1-.03-.191c.47.245 1.05.533 1.432.698z"
        fill="url(#p)"
      />
      <path
        d="m30.073 30.108.066.029a1.031 1.031 0 0 0-.066-.029z"
        fill="#BE202E"
      />
      <path
        opacity=".35"
        d="m30.073 30.108.066.029a1.031 1.031 0 0 0-.066-.029z"
        fill="#BE202E"
      />
      <path
        d="m30.073 30.108.066.029a1.031 1.031 0 0 0-.066-.029z"
        fill="url(#q)"
      />
      <path d="m30.057 29.515-.021-.008.021.008z" fill="#BE202E" />
      <path
        opacity=".35"
        d="m30.057 29.515-.021-.008.021.008z"
        fill="#BE202E"
      />
      <path d="m30.057 29.515-.021-.008.021.008z" fill="url(#r)" />
      <defs>
        <linearGradient
          id="a"
          x1="36.658"
          y1="26.611"
          x2="39.079"
          y2="25.908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F69923" />
          <stop offset=".312" stopColor="#F79A23" />
          <stop offset=".838" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="29.988"
          y1="34.736"
          x2="35.371"
          y2="26.637"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="31.688"
          y1="35.589"
          x2="34.661"
          y2="31.015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset=".095" stopColor="#662E8D" />
          <stop offset=".788" stopColor="#9F2064" />
          <stop offset=".949" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="d"
          x1="29.996"
          y1="35.063"
          x2="35.525"
          y2="26.622"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="e"
          x1="30.467"
          y1="35.32"
          x2="33.405"
          y2="30.617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset=".095" stopColor="#662E8D" />
          <stop offset=".788" stopColor="#9F2064" />
          <stop offset=".949" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="f"
          x1="31.305"
          y1="35.465"
          x2="36.542"
          y2="27.566"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="g"
          x1="31.191"
          y1="34.931"
          x2="36.168"
          y2="27.264"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="h"
          x1="32.03"
          y1="35.34"
          x2="36.153"
          y2="27.647"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="i"
          x1="32.076"
          y1="35.78"
          x2="36.676"
          y2="27.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="j"
          x1="30.759"
          y1="25.77"
          x2="28.143"
          y2="24.106"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F69923" />
          <stop offset=".312" stopColor="#F79A23" />
          <stop offset=".838" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="k"
          x1="35.473"
          y1="37.483"
          x2="36.267"
          y2="26.559"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="l"
          x1="32.144"
          y1="36.3"
          x2="32.557"
          y2="30.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset=".095" stopColor="#662E8D" />
          <stop offset=".788" stopColor="#9F2064" />
          <stop offset=".949" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="34.673"
          y1="37.143"
          x2="35.461"
          y2="25.837"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="n"
          x1="33.187"
          y1="36.412"
          x2="33.563"
          y2="30.266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282662" />
          <stop offset=".095" stopColor="#662E8D" />
          <stop offset=".788" stopColor="#9F2064" />
          <stop offset=".949" stopColor="#CD2032" />
        </linearGradient>
        <linearGradient
          id="o"
          x1="33.224"
          y1="36.934"
          x2="33.992"
          y2="26.306"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="p"
          x1="34.133"
          y1="36.96"
          x2="34.822"
          y2="26.773"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="q"
          x1="32.555"
          y1="35.525"
          x2="32.586"
          y2="26.835"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
        <linearGradient
          id="r"
          x1="32.673"
          y1="35.301"
          x2="32.55"
          y2="26.638"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".323" stopColor="#9E2064" />
          <stop offset=".63" stopColor="#C92037" />
          <stop offset=".751" stopColor="#CD2335" />
          <stop offset="1" stopColor="#E97826" />
        </linearGradient>
      </defs>
    </svg>
  );
};
